<template>
  <input
    :type="type"
    class="ha-builder-control"
    :value="modelValue"
    :placeholder="placeholder"
    @input="$emit('update:modelValue', $event.target.value)" />
</template>

<script setup>
/**
 * BuilderInput.vue
 *
 * The dense, dark-panel text/number <input> used throughout the Home
 * Assistant builder dialogs — see BuilderSelect.vue's doc comment for
 * why this exists separately from the global form-input component
 * (that one's colors are unreachable from a usage site's `class`).
 * Root element is the <input> itself, so sizing/spacing classes passed
 * at the call site apply directly to it.
 */
defineProps({
  modelValue:  { type: [String, Number], default: '' },
  type:        { type: String, default: 'text' },
  placeholder: { type: String, default: '' },
});
defineEmits(['update:modelValue']);
</script>
